import tokens from '@/PrimeVue/customDesignTokens';

export const selectUploadsDt = {
  colorScheme: {
    light: {
      background: tokens.button.background.colors.default,
      borderColor: tokens.button.border.colors.default,
      hoverBorderColor: tokens.button.border.colors.hover,
      borderRadius: tokens.button.border.radius,
      shadow: tokens.primitive.shadows.none,
      transitionDuration: '0s',
      paddingX: '0',
      paddingY: tokens.button.sm.paddingY
    }
  }
};

export const selectUploadsPt = (options?: { title: string }) => ({
  root: 'select-uploads-root',
  option: 'select-uploads-option',
  label: { 'title': options?.title }
});